import React, { useState, useEffect } from 'react';
import useAuth from '../../auth/useAuth';
import { settings, getLanguageObj } from '../../helpers/UtilsHelper';
import { GlobalFormats } from '../../classes/main/globalFormatClass';

const { app, icons, labels } = settings;
const { urls } = app?.backend;

const currentMethod = 'Header - function';

export default function Header({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    const auth = useAuth();
    const themeKey = settings?.localStorage?.theme;

    const [currentTheme, setCurrentTheme] = useState(() => {
        const saved = localStorage.getItem(themeKey);
        if (saved) return saved;
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    });

    const toggleTheme = () => {
        const newTheme = currentTheme === 'light' ? 'dark' : 'light';
        setCurrentTheme(newTheme);
        localStorage.setItem(themeKey, newTheme);
        document.documentElement.setAttribute('data-theme', newTheme);
    };

    useEffect(() => {
        const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        const savedTheme = localStorage.getItem(themeKey) || (systemPrefersDark ? 'dark' : 'light');
        if (savedTheme !== currentTheme) {
            setCurrentTheme(savedTheme);
        }
    }, [themeKey]); // eslint-disable-line

    return (
        <nav className='main-header navbar navbar-expand navbar-white navbar-light border-bottom-0 shadow-sm header-glassmorphism'>

            {/* Left navbar links */}
            <ul className='navbar-nav'>
                <li className='nav-item'>
                    <a className='nav-link nav-link-rounded' data-widget='pushmenu' href={urls?.home} role='button'>
                        <i className={icons?.fasFa?.alignJustify} />
                    </a>
                </li>
                <li className='nav-item d-none d-sm-inline-block'>
                    <a href={urls?.home} className='nav-link font-weight-bold text-dark'>
                        {labels?.home?.[languageObj?.id]}
                    </a>
                </li>
                <li className='nav-item d-none d-sm-inline-block'>
                    <a href={urls?.contac} className='nav-link text-muted'>
                        {labels?.contact?.[languageObj?.id]}
                    </a>
                </li>
            </ul>

            {/* Right navbar links */}
            <ul className='navbar-nav ml-auto'>
                {/* Navbar Search */}
                <li className='nav-item'>
                    <a className='nav-link' data-widget='navbar-search' href={urls?.home} role='button'>
                        <i className={icons?.fasFa?.search} />
                    </a>
                    <div className='navbar-search-block'>
                        <form className='form-inline'>
                            <div className='input-group input-group-sm bg-light p-1 search-group-rounded'>
                                <input className='form-control form-control-navbar border-0 bg-transparent search-input-sm'
                                    type='search'
                                    placeholder={labels?.search?.[languageObj?.id]}
                                    aria-label='Search' />
                                <div className='input-group-append'>
                                    <button className='btn btn-navbar text-primary' type='submit'>
                                        <i className={icons?.fasFa?.search} />
                                    </button>
                                    <button className='btn btn-navbar text-muted' type='button' data-widget='navbar-search'>
                                        <i className={icons?.fasFa?.close} />
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </li>

                {/* Messages Dropdown Menu */}
                {/*auth.isLoged() ? (
                <div>
                    <li className='nav-item dropdown'>
                        <a className='nav-link' data-toggle='dropdown' href={urls?.home}>
                            <i className='far fa-comments' />
                            <span className='badge badge-danger navbar-badge'>3</span>
                        </a>
                        <div className='dropdown-menu dropdown-menu-lg dropdown-menu-right'>
                            <a href={urls?.home} className='dropdown-item'>
                            {// Message Start /}
                            <div className='media'>
                                <img src='dist/img/user1-128x128.jpg' alt='User Avatar' className='img-size-50 mr-3 img-circle' />
                                <div className='media-body'>
                                <h3 className='dropdown-item-title'>
                                    Brad Diesel
                                    <span className='float-right text-sm text-danger'><i className='fas fa-star' /></span>
                                </h3>
                                <p className='text-sm'>Call me whenever you can...</p>
                                <p className='text-sm text-muted'><i className='far fa-clock mr-1' /> 4 Hours Ago</p>
                                </div>
                            </div>
                            {// Message End }
                            </a>
                            <div className='dropdown-divider' />
                            <a href={urls?.home} className='dropdown-item'>
                            {// Message Start /}
                            <div className='media'>
                                <img src='dist/img/user8-128x128.jpg' alt='User Avatar' className='img-size-50 img-circle mr-3' />
                                <div className='media-body'>
                                <h3 className='dropdown-item-title'>
                                    John Pierce
                                    <span className='float-right text-sm text-muted'><i className='fas fa-star' /></span>
                                </h3>
                                <p className='text-sm'>I got your message bro</p>
                                <p className='text-sm text-muted'><i className='far fa-clock mr-1' /> 4 Hours Ago</p>
                                </div>
                            </div>
                            {// Message End /}
                            </a>
                            <div className='dropdown-divider' />
                            <a href={urls?.home} className='dropdown-item'>
                            {// Message Start /}
                            <div className='media'>
                                <img src='dist/img/user3-128x128.jpg' alt='User Avatar' className='img-size-50 img-circle mr-3' />
                                <div className='media-body'>
                                <h3 className='dropdown-item-title'>
                                    Nora Silvester
                                    <span className='float-right text-sm text-warning'><i className='fas fa-star' /></span>
                                </h3>
                                <p className='text-sm'>The subject goes here</p>
                                <p className='text-sm text-muted'><i className='far fa-clock mr-1' /> 4 Hours Ago</p>
                                </div>
                            </div>
                            {// Message End /}
                            </a>
                            <div className='dropdown-divider' />
                            <a href={urls?.home} className='dropdown-item dropdown-footer'>See All Messages</a>
                        </div>
                    </li>
                </div>
                 ) : (<></>)*/}

                {/* Theme Toggle */}
                <li className='nav-item'>
                    <a className='nav-link nav-link-rounded' onClick={toggleTheme} role='button' title={currentTheme === 'light' ? 'Dark Mode' : 'Light Mode'}> {/* eslint-disable-line */}
                        <i className={currentTheme === 'light' ? icons?.farFa?.moon : icons?.farFa?.sun} />
                    </a>
                </li>

                {/* Notifications Dropdown Menu */}
                {auth.isLoged() ? (
                    <li className='nav-item dropdown'>
                        <a className='nav-link position-relative' data-toggle='dropdown' href={urls?.home}>
                            <i className={icons?.fasFa?.bell} />
                            <span className='badge badge-warning navbar-badge notification-badge'>15</span>
                        </a>
                        <div className='dropdown-menu dropdown-menu-lg dropdown-menu-right border-0 shadow-lg dropdown-notifications'>
                            <span className='dropdown-item dropdown-header font-weight-bold py-3'>15 Notifications</span>
                            <div className='dropdown-divider mx-3' />
                            <a href={urls?.home} className='dropdown-item py-3'>
                                <i className={`${icons?.fasFa?.envelope} mr-3 text-primary`} />
                                <span className='notification-text'>4 new messages</span>
                                <span className='float-right text-muted text-sm mt-1'>3 mins</span>
                            </a>
                            <div className='dropdown-divider mx-3' />
                            <a href={urls?.home} className='dropdown-item py-3'>
                                <i className={`${icons?.fasFa?.users} mr-3 text-success`} />
                                <span className='notification-text'>8 friend requests</span>
                                <span className='float-right text-muted text-sm mt-1'>12 hours</span>
                            </a>
                            <div className='dropdown-divider mx-3' />
                            <a href={urls?.home} className='dropdown-item py-3'>
                                <i className={`${icons?.fasFa?.fileAlt || 'fas fa-file'} mr-3 text-warning`} />
                                <span className='notification-text'>3 new reports</span>
                                <span className='float-right text-muted text-sm mt-1'>2 days</span>
                            </a>
                            <div className='dropdown-divider' />
                            <a href={urls?.home} className='dropdown-item dropdown-footer py-3 font-weight-bold text-primary'>See All Notifications</a>
                        </div>
                    </li>
                ) : (<></>)}

                {/*<li className='nav-item'>
                            <a className='nav-link' data-widget='fullscreen' href={urls?.home} role='button'>
                                <i className='fas fa-expand-arrows-alt' />
                            </a>
                        </li>
                        <li className='nav-item'>
                            <a className='nav-link' data-widget='control-sidebar' data-slide='true' href={urls?.home} role='button'>
                                <i className='fas fa-th-large' />
                            </a>
                    </li>*/}

            </ul>
        </nav >
    );
}